import { Injectable } from '@angular/core';
export type FramedElementKeyType =
    | 'prompt'
    | 'projectSettings'
    | 'projectInvite'
    | 'nextScene'
    | 'showTimeline'
    | 'projectSuggestions';
@Injectable({
    providedIn: 'root',
})
@Injectable({ providedIn: 'root' })
export class FramedService {
    private framed = false;
    initialized = false;
    private visibilityMap: Record<FramedElementKeyType, { hide: boolean }> = {
        prompt: { hide: false },
        projectSettings: { hide: false },
        projectInvite: { hide: false },
        nextScene: { hide: false },
        showTimeline: { hide: false },
        projectSuggestions: { hide: false },
    };
    setFramed(isFramed: boolean): void {
        sessionStorage.setItem('isFramed', JSON.stringify(isFramed));
        Object.values(this.visibilityMap).forEach((entry) => {
            entry.hide = isFramed;
        });
        this.framed = isFramed;
    }
    isFramed(): boolean {
        return this.framed;
    }
    isHidden(key: string): boolean {
        return this.visibilityMap[key]?.hide ?? false;
    }

    setHidden(key: string, hide: boolean): void {
        if (!this.visibilityMap[key]) {
            this.visibilityMap[key] = { hide };
        } else {
            this.visibilityMap[key].hide = hide;
        }
    }
}
